import { customProp, quickProperty, designToken } from '../component-tokens';
import { borderBase, focusState } from './common';
import { sizeAttributes } from './utils';
export const checkboxTokens = {
    name: 'checkbox',
    tag: 'chameleon-checkbox',
    reactImports: 'Checkbox',
    attributes: {
        cursor: quickProperty('pointer'),
        position: quickProperty('relative'),
        display: quickProperty('inline-flex'),
        'align-items': quickProperty('center'),
        outline: quickProperty('0'),
    },
    children: [
        {
            name: 'control',
            attributes: Object.assign(Object.assign(Object.assign({}, borderBase), sizeAttributes('16px')), { position: quickProperty('relative'), 'box-sizing': quickProperty('border-box'), outline: quickProperty('none'), 'border-radius': quickProperty('4px'), 'border-color': designToken('ui-03'), 'background-color': designToken('ui-01'), 'flex-shrink': quickProperty('0'), 'margin-top': quickProperty('1px') }),
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('hover-01'),
                        'border-color': designToken('ui-03'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('pressed-01'),
                        'border-color': designToken('ui-03'),
                        'box-shadow': quickProperty('none'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign({}, focusState),
                },
                {
                    name: 'checked',
                    attributes: {
                        'background-color': designToken('information-01'),
                        'border-color': designToken('information-01'),
                        color: designToken('text-06'),
                    },
                },
                {
                    name: 'checked-hover',
                    attributes: {
                        'background-color': designToken('hover-primary'),
                        'border-color': designToken('hover-primary'),
                    },
                },
                {
                    name: 'checked-active',
                    attributes: {
                        'background-color': designToken('pressed-primary'),
                        'border-color': designToken('pressed-primary'),
                    },
                },
            ],
        },
        {
            name: 'label',
            attributes: {
                color: designToken('text-01'),
                cursor: quickProperty('pointer'),
                font: designToken('body-small'),
                'margin-left': quickProperty('8px'),
            },
        },
    ],
    sizes: [
        {
            name: 'large',
            children: [
                {
                    name: 'control',
                    attributes: Object.assign({}, sizeAttributes('20px')),
                },
                {
                    name: 'label',
                    attributes: {
                        font: designToken('body-medium'),
                    },
                },
            ],
        },
    ],
    states: [
        {
            name: 'hover',
            attributes: {
                'background-color': designToken('hover-01'),
            },
        },
        {
            name: 'focus',
            attributes: Object.assign(Object.assign({}, focusState), { 'background-color': customProp('checkbox-focus-bg-color') }),
        },
        {
            name: 'active',
            attributes: {
                'background-color': designToken('pressed-01'),
                'border-color': designToken('ui-03'),
                'box-shadow': quickProperty('none'),
            },
        },
        {
            name: 'checked',
            attributes: {
                'background-color': designToken('interactive-01'),
                'border-color': designToken('interactive-01'),
            },
        },
        {
            name: 'checked-active',
            attributes: {
                'background-color': designToken('pressed-primary'),
                'border-color': designToken('pressed-primary'),
                'box-shadow': quickProperty('none'),
            },
        },
    ],
    variants: [
        {
            name: 'disabled',
            attributes: {
                cursor: quickProperty('default'),
            },
            children: [
                {
                    name: 'label',
                    attributes: {
                        cursor: quickProperty('default'),
                        color: designToken('text-03'),
                    },
                },
                {
                    name: 'control',
                    attributes: {
                        'background-color': designToken('disabled-04'),
                        'border-color': designToken('toolbar-disabled-icon-color'),
                        color: designToken('text-06'),
                    },
                },
            ],
        },
        {
            name: 'disabled-checked',
            children: [
                {
                    name: 'control',
                    attributes: {
                        'background-color': designToken('toolbar-disabled-icon-color'),
                        'border-color': designToken('toolbar-disabled-icon-color'),
                        color: designToken('text-06'),
                    },
                },
            ],
        },
    ],
};
